import type { ReportTemplate } from '@/versions/v1/schema/report';

/** Templates whose whole body is money — not templates that only gate a financial block. */
export function reportTemplateCarriesMoney(template: ReportTemplate): boolean {
  return template.id === 'tpl-daily-accounting' || template.id === 'tpl-weekly-summary';
}
